import styled from "styled-components";

export const RegisterContainer = styled.div`
  margin: 0 60px;
  display: flex;
  justify-content: space-evenly;
`;
export const RegisterText = styled.div`
  width: 40%;
`;
export const RegisterTitle = styled.h2`
  font-size: 24px;
  font-weight: 700;
  margin: 30px 0;
`;
export const RegisterDescription = styled.p`
  font-size: 14px;
`;
export const RegisterForm = styled.form`
  width: 30%;
`;
